export const getStatistics = statistics => ({
  type: 'GET_STATISTICS',
  statistics
})
